import useTwinTranslation from '../../../../../../../../utils/hooks/useTwinTranslation'
import ModalDeleteFilled from '../../../../../../../../baseComponents/ModalsLayouts/ModalDeleteFilled'
import { ModalEditComponentProps } from '../../../../../../../../baseComponents/ModalsLayouts/types'
import { OrderURLsTable } from '../../../../types'

interface ModalDeleteLineOrderProps extends ModalEditComponentProps {
    orderURLs: OrderURLsTable
}

const ModalDeleteLineOrder: React.FC<ModalDeleteLineOrderProps> = ({ setOpened, onSubmit, allRowData }) => {
    const { t } = useTwinTranslation()
    return (
        <ModalDeleteFilled opened={true} setOpened={setOpened} onCancel={() => setOpened(null)} onAccept={() => onSubmit(allRowData?.id, {})} translations={{
            title: t('sureDeleteLine', '¿Seguro quieres eliminar esta línea?'),
            subtitle: t('onceDeletedNotRecoverM', 'Una vez eliminado no podrás recuperarlo')
        }} />
    )
}
export default ModalDeleteLineOrder